import is from 'is_js';
import filter from 'lodash/filter';

const searchFilterApiAdapter = (searchFilterValues) => {
  const Keyword = searchFilterValues.keyword
    ?
    {
      Name: 'Keyword',
      Value: searchFilterValues.keyword,
    }
    :
    null;

  const StartDate = searchFilterValues.dateRange.start
    ?
    {
      Name: 'StartDate',
      Value: searchFilterValues.dateRange.start,
    }
    :
    null;

  const EndDate = searchFilterValues.dateRange.end
    ?
    {
      Name: 'EndDate',
      Value: searchFilterValues.dateRange.end,
    }
    :
    null;

  const AreasOfLaw = searchFilterValues.areasOfLaw
    ?
    {
      Name: 'AreasOfLaw',
      Values: searchFilterValues.areasOfLaw.map(resource => resource.filterId),
    }
    :
    null;

  const Publications = searchFilterValues.publications
    ?
    {
      Name: 'Publications',
      Values: searchFilterValues.publications.map(publication => publication.filterId),
    }
    :
    null;

  const ResourceTypes = searchFilterValues.resourceTypes
    ?
    {
      Name: 'ResourceTypes',
      Values: searchFilterValues.resourceTypes.map(resourceType => resourceType.filterId),
    }
    :
    null;

  const possibleFilters = [
    AreasOfLaw,
    Keyword,
    StartDate,
    EndDate,
    Publications,
    ResourceTypes,
  ];

  return filter(possibleFilters, item => is.not.null(item));
};

export default searchFilterApiAdapter;
